var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M18 5V2H30V5ZM22.5 27.35H25.5V15.85H22.5ZM24 43.95Q20.3 43.95 17.025 42.525Q13.75 41.1 11.3 38.65Q8.85 36.2 7.425 32.925Q6 29.65 6 25.95Q6 22.25 7.425 18.975Q8.85 15.7 11.3 13.25Q13.75 10.8 17.025 9.375Q20.3 7.95 24 7.95Q27.35 7.95 30.3 9.075Q33.25 10.2 35.55 12.2L38.1 9.65L40.2 11.75L37.65 14.3Q39.45 16.3 40.725 19.15Q42 22 42 25.95Q42 29.65 40.575 32.925Q39.15 36.2 36.7 38.65Q34.25 41.1 30.975 42.525Q27.7 43.95 24 43.95ZM24 40.95Q30.25 40.95 34.625 36.575Q39 32.2 39 25.95Q39 19.7 34.625 15.325Q30.25 10.95 24 10.95Q17.75 10.95 13.375 15.325Q9 19.7 9 25.95Q9 32.2 13.375 36.575Q17.75 40.95 24 40.95ZM24 26Q24 26 24 26Q24 26 24 26Q24 26 24 26Q24 26 24 26Q24 26 24 26Q24 26 24 26Q24 26 24 26Q24 26 24 26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeout);
export default __webpack_public_path__ + "static/media/timeout.741ef017399590a48b987e513d33f6ca.svg";
export { ForwardRef as ReactComponent };